import React from "react";
import { Lock, Sparkles } from "lucide-react";
import { Link } from "react-router-dom";

export default function VisionStudioGate({ access }) {
  if (!access) return null;
  const plan = (access.plan || "free").replace("_", " ");
  return (
    <div className="p-6 md:p-10 max-w-4xl mx-auto animate-fade-up" data-testid="vision-gate">
      <div className="rounded-2xl border border-brand-amber/40 bg-gradient-to-br from-brand-amber/15 via-bg-surface to-brand-blue/10 p-8 md:p-12 relative overflow-hidden">
        <div className="absolute inset-0 opacity-30 mix-blend-screen pointer-events-none" style={{
          backgroundImage: "radial-gradient(circle at 20% 20%, #FF8A1F, transparent 50%), radial-gradient(circle at 80% 80%, #0093FF, transparent 55%)",
        }} />
        <div className="relative">
          <div className="inline-flex items-center gap-2 rounded-full bg-brand-amber/20 text-brand-amber px-3 py-1 text-[11px] font-mono uppercase tracking-wider mb-4">
            <Lock className="h-3.5 w-3.5" /> Pro Radio &amp; Network exclusive
          </div>
          <h1 className="font-display text-4xl md:text-5xl font-bold tracking-tight mb-3">
            BroadcastFlow <span className="text-brand-amber">Vision Studio</span>
          </h1>
          <p className="text-lg text-ink-secondary mb-8 max-w-2xl">
            The industry&apos;s first AI broadcast video studio. Transform news, podcasts, artist spotlights and station promos into professional videos using Veo, Sora, Runway, Pika, Luma, Kling, Hailuo &amp; more — from one centralized dashboard.
          </p>

          <div className="grid md:grid-cols-3 gap-3 mb-8 text-sm">
            {[
              ["AI Script Generator", "Full broadcast script with scenes, narration, camera directions, lower-thirds & music cues."],
              ["AI Storyboard", "Auto-generated scene-by-scene visual prompts ready for any video provider."],
              ["12 Video Providers", "Bring your own keys to Veo · Sora · Runway · Pika · Luma · Kling · Hailuo · Minimax · Flow3 · Flova.ai & more."],
              ["Brand Kit", "Station logo, colors, fonts auto-applied to every output."],
              ["AI Project Manager", "One click: script → storyboard → narration → render → publish."],
              ["Auto-publish", "Push finished videos to YouTube, Facebook, Instagram, TikTok, Threads, WordPress."],
            ].map(([title, body], i) => (
              <div key={i} className="rounded-xl border border-line bg-bg-elevated/80 p-4">
                <div className="font-display font-bold mb-1 text-brand-blue flex items-center gap-2">
                  <Sparkles className="h-4 w-4" /> {title}
                </div>
                <div className="text-xs text-ink-muted">{body}</div>
              </div>
            ))}
          </div>

          <div className="text-xs text-ink-muted mb-4">
            Your current plan: <span className="font-mono uppercase text-ink-secondary">{plan}</span>. Upgrade to <span className="text-brand-amber font-semibold">Pro Radio ($299/mo)</span> or <span className="text-brand-blue font-semibold">Network ($499/mo)</span> to unlock.
          </div>
          <div className="flex flex-wrap gap-3">
            <Link
              to="/dashboard/billing?tab=credits"
              data-testid="vision-upgrade-btn"
              className="inline-flex items-center gap-2 rounded-md bg-brand-amber text-bg px-5 py-3 font-bold hover:bg-brand-amber/90 transition"
            >
              Upgrade to Pro Radio →
            </Link>
            <Link
              to="/dashboard"
              className="inline-flex items-center gap-2 rounded-md border border-line bg-bg-elevated px-5 py-3 text-sm hover:border-brand-blue transition"
            >
              Back to dashboard
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}
